import React from 'react'
import ReactMarkdown from 'react-markdown'
import { Modal, Glyphicon } from 'react-bootstrap'

import Button from '../components/Button'
import TripNotesEditor from './TripNotesEditor'

type Props = {
  trip: Object
}

const renderMsg = msg => (
  <div key={msg.id} style={{ marginTop: -9 }}>
    <span style={{ fontSize: 12 }}>
      <span style={{ color: "green" }}>
        {
          msg.pinned ? "📌 " : "🗨 "
        }
      </span>
      <strong>{msg.author} </strong>
      <i> - {msg.creation}</i>
    </span>
    <ReactMarkdown style={{display: "inline"}} source={msg.text} />
  </div>
)

class TripNotesDisplay extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = { modal: false }
  }

  props: Props

  render() {
    const { notes } = this.props.trip

    return (
      <React.Fragment>
        <div
          style={{position: "relative", minHeight: 65, paddingTop: 4, marginBottom: -8, height: 250, overflow: 'auto' }}
          onClick={() => { this.setState({ modal: true }) }}
        >
          {
            notes.map(note => { return renderMsg(note) })
          }

          <Glyphicon
            glyph="pencil"
            style={{ position: "absolute", fontSize: "14", right: 5, top: 5, opacity: 0.5 }}
          />
        </div>

        {
          this.state.modal && (
            <Modal show onHide={() => this.setState({ modal: false })}>
              <Modal.Header>
                <Modal.Title>
                  Mensajes sobre {this.props.trip.realName || this.props.trip.name || <i>[Cliente sin nombre]</i>}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <TripNotesEditor
                  panel={false}
                  trip={this.props.trip}
                />
              </Modal.Body>
              <Modal.Footer>
                <Button
                  onClick={() => { this.setState({ modal: false }) }}
                >
                  Cerrar
                </Button>
              </Modal.Footer>
            </Modal>
          )
        }
      </React.Fragment>
    )
  }
}

export default TripNotesDisplay
